import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import { AchievementCreate } from "./create";
import { AchievementEdit } from "./edit";
import { AchievementList } from "./list";

export const AchievementIcon = EmojiEventsIcon;

export { AchievementCreate, AchievementEdit, AchievementList };
